import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material';

import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CropperSettings } from 'ngx-img-cropper';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined, log } from 'util';
import { config } from '../../../../../config/config';
import { HubFacebookFeedsCommand } from '../../../../commands/hub/event/add.facebook.general.feed.command';
import { StyleCommand, StyleModel } from '../../../../commands/hub/style.command';
import { UpdateCityCommand } from '../../../../commands/hub/update.city.command';
import { VisitorSettingsCommand } from '../../../../commands/pagination.query.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ImageSelectorComponent } from '../../../../common/components/image.selector/image.selector.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { ImageService } from '../../../../services/image.service';
import { VisitorDataCache } from '../../../../stores/visitor.calendar.store';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { AlertifyService } from '../../../../services/alertify.service';
import { AddCityModalComponent } from '../../add.city.modal/add.city.modal.component';
import { AddCityModalActions, AddCityModalData } from '../../add.city.modal/add.city.modal.provider';
import { AssignTourModalComponent } from '../../assign.tour.modal/assign.tour.modal.component';
import { EditCityModalComponent } from '../../edit.city.modal/edit.city.modal.component';
import { EditCityModalActions } from '../../edit.city.modal/edit.city.modal.provider';
import { LogoCommand, PDFSettingCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubFeed } from '../../../../models/hub/hub.feed';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { EventTimeService } from '../../../../services/event.time.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import {
  HubFacebookLocationFeedsStore,
  HubFacebookPageFeedsStore,
  HubLogoStore,
  PDFSettingsStore,
  ToggleStore,
} from '../../../../stores/hub.calendar.store';
import { HubComponent } from '../../hub.component';
import {
  AssignTourModalActions,
  AssignTourModalData,
} from 'components/hub/assign.tour.modal/assign.tour.modal.provider';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AccountApiService } from '../../../../services/account.api.service';
import * as jwt_decode from 'jwt-decode';
import { TokenInfo } from '../../../../models/auth/token.info';

@Component({
  templateUrl: './style.component.html',
  styleUrls: ['./style.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StyleComponent extends BaseComponent implements OnInit {
  @ViewChildren('defaultbtn') defaultButtons: QueryList<ElementRef>;
  @ViewChildren('eventbtn') eventButtons: QueryList<ElementRef>;
  @ViewChildren('placebtn') placeButtons: QueryList<ElementRef>;
  @ViewChildren('pinnedborder') pinnedEventBorders: QueryList<ElementRef>;
  @ViewChildren('detailButton') detailButtons: QueryList<ElementRef>;
  @ViewChildren('sidebarUnderline') sidebarUnderlines: QueryList<ElementRef>;
  @ViewChild('logoimage') logoImage: ElementRef;
  @ViewChild('pdfeventimage') pdfEventImage: ElementRef;
  @ViewChild('pdfplaceimage') pdfPlaceImage: ElementRef;
  @ViewChild('pdftourimage') pdfTourImage: ElementRef;
  @ViewChild('pdftripimage') pdfTripImage: ElementRef;
  @ViewChild('tpHomeImg') tpHomeImg: ElementRef;
  @ViewChild('savelogosuccess') public saveLogoSuccess: SuccessWrapComponent;
  @ViewChild('saveTPHomeImagesuccess') public saveTPHomeImagesuccess: SuccessWrapComponent;
  @ViewChild('savepdfsuccess') public savePDFScussess: SuccessWrapComponent;
  @ViewChild('eventImgCropper') eventImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('placeImgCropper') placeImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('logoCropper') logoCropper: ImageCropperWithPreviewComponent;
  @ViewChild('tab') tab: MatTabGroup;
  @ViewChildren('imageselector') public imageSelectors: QueryList<ImageSelectorComponent>;
  public updateCityCommand = new UpdateCityCommand();
  public editingImageData: string;
  public form: FormGroup;

  public hubName = null;
  public calendarStyle: {
    event: 'default' | 'square' | 'long' | 'modern-block';
    place: 'default' | 'square' | 'long' | 'tile';
    eventDetails: 'default' | 'fancy';
  };
  public isLoadingCalendarStyle = false;
  public isLoadingMenuStyle = false;
  public isSideBar = true;
  public isHideEditorChoice = true;
  public isLoadingFeeds = false;
  public defaultImg = config.defaultImageUrl;
  public sidebarImage = config.sidebarImageUrl;
  public topbarImage = config.topbarImageUrl;
  public tourSideImg = config.tripPlannerTourSideImg;
  public mapImg = config.mapImg;
  public timeSample = EventTimeService.convert(new Date());
  public cards = [1];
  public style = new StyleModel();
  public defaultStyle = new StyleCommand();
  public customEventForm: FormGroup;
  public logo = {
    isDefault: true,
    url: '',
  };
  public tpHomeImage = {
    isDefault: true,
    url: '',
  };
  public logoData: any;
  public tpHomeImageData: any;
  public maxCroppedWidth = 800;
  public cropperSettings: CropperSettings;
  public cropperSettingsForPDF: CropperSettings;
  public PDFSettings: PDFSettingCommand;
  public PDFSettingImageCorperData: {
    event: any;
    place: any;
    tour: any;
    trip: any;
  };
  public featuresToggle = new HubVisitorFeatureToggle();
  public hubLocations: HubFeed[];
  public multiCities = {
    active: false,
    cityBlock: {
      active: true,
    },
    regions: [
      // {
      //     name: 'Northwest',
      //     cities: []
      // }, {
      //     name: 'Southeast',
      //     cities: []
      // }
    ],
    tours: [],
  };
  public tpBG = config.tripPlannerWelcomeImg;
  public version = {
    event: {
      version: 'V2',
    },
    place: {
      version: 'V2',
    },
    tripPlanner: {
      version: 'V2',
    },
    clientDashboard: {
      version: 'V2',
    },
  };

  constructor(
    private hubApiService: HubApiService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private customizationService: CustomizationApiService,
    private parent: HubComponent,
    private modalService: ModalService,
    private imageService: ImageService,
    private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
    private hubLogoStore: HubLogoStore,
    private pdfSettingsStore: PDFSettingsStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
    private alertify: AlertifyService,
    private visitorApiService: VisitorApiService,
    private togglesStore: ToggleStore,
    private cd: ChangeDetectorRef
  ) {
    super({ activatedRoute });

    this.cropperSettings = new CropperSettings();
    this.cropperSettingsForPDF = new CropperSettings();

    this.logoData = {};
    this.tpHomeImageData = {};
    this.PDFSettings = {
      pdf: {
        headerImage: {
          event: { isDefault: true, url: null },
          place: { isDefault: true, url: null },
          tour: { isDefault: true, url: null },
          trip: { isDefault: true, url: null },
        },
      },
      eventCalendarURL: null,
      placeCalendarURL: null,
      moreToursURL: null,
    };
    this.PDFSettingImageCorperData = {
      event: {},
      place: {},
      tour: {},
      trip: {},
    };

    this.form = this.formBuilder.group({
      regionName: [null, []],
    });

    this.tpBG = this.imageService.imageSourceUrl(this.tpBG);
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.parent.location = 'Style Customization';
    this.isLoadingCalendarStyle = true;
    this.isLoadingMenuStyle = true;

    this.customEventForm = this.formBuilder.group({
      btnText: [null, []],
      type: [null, []],
      feedId: [null, []],
    });

    setTimeout(() => {
      this.defaultStyle.defaultButton.backgroundColor = this.defaultButtons.first.nativeElement.style.backgroundColor;
      this.defaultStyle.eventButton.backgroundColor = this.eventButtons.first.nativeElement.style.backgroundColor;
      this.defaultStyle.placeButton.backgroundColor = this.placeButtons.first.nativeElement.style.backgroundColor;
      this.defaultStyle.pinnedEventBorder.borderColor =
        this.pinnedEventBorders.first.nativeElement.style.backgroundColor;
      this.defaultStyle.detailButton.backgroundColor = this.detailButtons.first.nativeElement.style.backgroundColor;
      this.defaultStyle.sidebarUnderline.color = this.sidebarUnderlines.first.nativeElement.style.backgroundColor;
    });

    this.customizationService.getStyle(this.hubName).subscribe((style) => {
      this.mapStyle(style);
    });

    this.customizationService.getCalendarStyle(this.hubName).subscribe((style) => {
      this.calendarStyle = {
        event: style && style.event ? style.event : style.style || 'default',
        place: style && style.place ? style.place : style.style || 'default',
        eventDetails: style && style.eventDetails ? style.eventDetails : style.eventDetails || 'default',
      };
      this.isLoadingCalendarStyle = false;
    });

    this.customizationService.getMenuStyle(this.hubName).subscribe((menuStyle) => {
      this.isSideBar = menuStyle.isSideBar == undefined || menuStyle.isSideBar;
      this.isLoadingMenuStyle = false;
    });

    this.customizationService.getIgVersion(this.hubName).subscribe((version) => {
      if (version && version.event) {
        this.version = version;
      }
      console.log('version', version);
    });

    setTimeout(() => {
      const rect = this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 2;
      const width = (rect.width - 18 * 4 - 12) / 2;
      const height = (width * 60) / 210;
      this.cropperSettingsForPDF = this.imageService.createImageCropperSetting(width, height, true);
      this.cropperSettings = this.imageService.createImageCropperSetting(width, height, false);

      this.customizationService.getLogo(this.hubName).subscribe((logo) => {
        this.logo.isDefault = isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault;
        this.logo.url = isNullOrUndefined(logo) ? null : logo.url;
        if (this.logo.url) {
          this.logoData.image = this.logo.url;
          console.log('logo', this.logo);
          // this.logoImageSet('logo');

          setTimeout(() => {
            // console.log('this.logoCropper', this.logoCropper);
            // this.logoCropper && this.logoCropper.setImage(this.logo.url);
            this.logoCropper && this.logoCropper.setImageData(this.cropperSettings);
          });
        }
      });

      this.customizationService.getPDFSettings(this.hubName).subscribe((settings: PDFSettingCommand) => {
        this.PDFSettings.pdf.headerImage.event.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
          settings.pdf.headerImage.event.isDefault;
        this.PDFSettings.pdf.headerImage.event.url = this.PDFSettings.pdf.headerImage.event.isDefault
          ? null
          : settings.pdf.headerImage.event.url;
        if (this.PDFSettings.pdf.headerImage.event.url && this.PDFSettings.pdf.headerImage.event.url.length) {
          this.PDFSettingImageCorperData.event.image = this.PDFSettings.pdf.headerImage.event.url[0];
        }

        this.PDFSettings.pdf.headerImage.place.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
          settings.pdf.headerImage.place.isDefault;
        this.PDFSettings.pdf.headerImage.place.url = this.PDFSettings.pdf.headerImage.place.isDefault
          ? null
          : settings.pdf.headerImage.place.url;
        if (this.PDFSettings.pdf.headerImage.place.url && this.PDFSettings.pdf.headerImage.place.url.length) {
          this.PDFSettingImageCorperData.place.image = this.PDFSettings.pdf.headerImage.place.url[0];
        }

        this.PDFSettings.pdf.headerImage.tour.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
          settings.pdf.headerImage.tour.isDefault;
        this.PDFSettings.pdf.headerImage.tour.url = this.PDFSettings.pdf.headerImage.tour.isDefault
          ? null
          : settings.pdf.headerImage.tour.url;
        if (this.PDFSettings.pdf.headerImage.tour.url) {
          this.PDFSettingImageCorperData.tour.image = this.PDFSettings.pdf.headerImage.tour.url;
        }

        this.PDFSettings.pdf.headerImage.trip.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
          settings.pdf.headerImage.trip.isDefault;
        this.PDFSettings.pdf.headerImage.trip.url = this.PDFSettings.pdf.headerImage.trip.isDefault
          ? null
          : settings.pdf.headerImage.trip.url;
        if (this.PDFSettings.pdf.headerImage.trip.url) {
          this.PDFSettingImageCorperData.trip.image = this.PDFSettings.pdf.headerImage.trip.url;
        }

        setTimeout(() => {
          this.eventImgCropper && this.eventImgCropper.setImageData(this.cropperSettingsForPDF);
          this.placeImgCropper && this.placeImgCropper.setImageData(this.cropperSettingsForPDF);
        });
      });
    });

    this.togglesStore.toggleCommand.takeUntil(this.isDestroyed).subscribe((toggle: HubVisitorFeatureToggle) => {
      if (toggle) {
        this.featuresToggle = toggle;
        this.featuresToggle.calendarViewLayout = !!toggle.calendarViewLayout;
        this.featuresToggle.itinerary = isNullOrUndefined(toggle.itinerary) ? true : toggle.itinerary;
        this.featuresToggle.multipleCities = !!toggle.multipleCities;
        if (this.multiCities.active) {
          this.hubApiService.getCityBlockToggle(this.hubName).subscribe((block) => {
            this.multiCities.cityBlock.active = !isNullOrUndefined(block.active) ? block.active : true;
          });
        }
      }
    });
  }

  public get canShowCalendarViewLayout(): boolean {
    return !!this.featuresToggle.calendarViewLayout;
  }

  public toDefault() {
    if (this.style.defaultButton.backgroundColor.isDefault) {
      this.style.defaultButton.backgroundColor.value = this.defaultStyle.defaultButton.backgroundColor;

      this.defaultButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.defaultButton.backgroundColor.value;
      });
    }
    if (this.style.eventButton.backgroundColor.isDefault) {
      this.style.eventButton.backgroundColor.value = this.defaultStyle.eventButton.backgroundColor;

      this.eventButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.eventButton.backgroundColor.value;
      });
    }
    if (this.style.placeButton.backgroundColor.isDefault) {
      this.style.placeButton.backgroundColor.value = this.defaultStyle.placeButton.backgroundColor;

      this.placeButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.placeButton.backgroundColor.value;
      });
    }
    if (this.style.pinnedEventBorder.borderColor.isDefault) {
      this.style.pinnedEventBorder.borderColor.value = this.defaultStyle.pinnedEventBorder.borderColor;

      this.pinnedEventBorders.forEach((x) => {
        x.nativeElement.style.borderColor = this.style.pinnedEventBorder.borderColor.value;
      });
    }
    if (this.style.detailButton.backgroundColor.isDefault) {
      this.style.detailButton.backgroundColor.value = this.defaultStyle.detailButton.backgroundColor;

      this.detailButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.detailButton.backgroundColor.value;
      });
    }
    if (this.style.sidebarUnderline.color.isDefault) {
      this.style.sidebarUnderline.color.value = this.defaultStyle.sidebarUnderline.color;

      this.sidebarUnderlines.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.sidebarUnderline.color.value;
      });
    }
  }

  public toTPDefault() { }

  public chooseColor() {
    setTimeout(() => {
      this.defaultButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.defaultButton.backgroundColor.value;
      });
      this.eventButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.eventButton.backgroundColor.value;
      });
      this.placeButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.placeButton.backgroundColor.value;
      });
      this.pinnedEventBorders.forEach((x) => {
        x.nativeElement.style.borderColor = this.style.pinnedEventBorder.borderColor.value;
      });
      this.detailButtons.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.detailButton.backgroundColor.value;
      });
      this.sidebarUnderlines.forEach((x) => {
        x.nativeElement.style.backgroundColor = this.style.sidebarUnderline.color.value;
      });
    });
  }

  public saveColor(event?: ButtonTriggerEvent) {
    const command = this.createCmdAndSetColor();

    // this.removeColorPrefix(command);
    this.customizationService
      .setStyle(this.hubName, command)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Change the color');
      });
  }

  public saveTPColor(param: { command: StyleCommand; event: ButtonTriggerEvent }) {
    console.log('param.command.tripPlanner', param.command.tripPlanner);
    const command = this.createCmdAndSetColor();
    command.tripPlanner = param.command.tripPlanner;

    // this.removeColorPrefix(command);
    this.customizationService
      .setStyle(this.hubName, command)
      .finally(param.event.complete)
      .subscribe(() => {
        this.alertify.successfully('Change the color');
      });
  }

  private createCmdAndSetColor() {
    let command = new StyleCommand();
    command.defaultButton.backgroundColor = this.style.defaultButton.backgroundColor.isDefault
      ? null
      : this.style.defaultButton.backgroundColor.value;
    command.eventButton.backgroundColor = this.style.eventButton.backgroundColor.isDefault
      ? null
      : this.style.eventButton.backgroundColor.value;
    command.placeButton.backgroundColor = this.style.placeButton.backgroundColor.isDefault
      ? null
      : this.style.placeButton.backgroundColor.value;
    command.pinnedEventBorder.borderColor = this.style.pinnedEventBorder.borderColor.isDefault
      ? null
      : this.style.pinnedEventBorder.borderColor.value;
    command.detailButton.backgroundColor = this.style.detailButton.backgroundColor.isDefault
      ? null
      : this.style.detailButton.backgroundColor.value;
    command.sidebarUnderline.color = this.style.sidebarUnderline.color.isDefault
      ? null
      : this.style.sidebarUnderline.color.value;
    return command;
  }

  private mapStyle(style: StyleCommand) {
    /**
     * utilize the server side stored style to UI
     * */
    Object.keys(this.style).forEach((x) => {
      if (x !== 'tripPlanner') {
        const colorType = ['backgroundColor', 'borderColor', 'color'].first((y) => !!this.style[x][y]);
        this.style[x][colorType].value = style[x][colorType] || this.defaultStyle[x][colorType];
        this.style[x][colorType].isDefault = !style[x][colorType];
        this[x + 's'].forEach((ele) => {
          ele.nativeElement.style[x === 'sidebarUnderline' ? 'backgroundColor' : colorType] =
            this.style[x][colorType].value;
        });
      } else {
        const defaultStyle = new StyleModel();
        Object.keys(style.tripPlanner).forEach((y) => {
          this.style.tripPlanner[y].color.value = style.tripPlanner[y].color || defaultStyle.tripPlanner[y].color.value;
          this.style.tripPlanner[y].color.isDefault = !style.tripPlanner[y].color;
        });
      }
    });
  }

  public setMenuStyle() {
    this.customizationService.setMenuStyle(this.hubName, this.isSideBar).subscribe(() => {
      this.alertify.successfully('Change the menu style');
    });
  }

  public setCalendarStyle() {
    this.customizationService.setCalendarStyle(this.hubName, this.calendarStyle).subscribe(() => {
      this.alertify.successfully('Change the calendar style');

      const settingStorage = localStorage.getItem(localStorageKeys.visitorSettings);
      if (settingStorage) {
        const visitorSettings = JSON.parse(settingStorage) as VisitorSettingsCommand;
        visitorSettings.calendarStyle = this.calendarStyle;
        localStorage.setItem(localStorageKeys.visitorSettings, JSON.stringify(visitorSettings));
      }
    });
  }

  public logoImageSet(type: string, isForPDF?: boolean) {
    setTimeout(() => {
      let width = 0,
        height = 0;
      if (!isForPDF) {
        width = Math.min(this.maxCroppedWidth, this.cropperSettings.croppedWidth);
        height = (width * this.cropperSettings.croppedHeight) / this.cropperSettings.croppedWidth;
      } else {
        width = Math.min(this.maxCroppedWidth, this.cropperSettings.croppedWidth);
        height = (width * this.cropperSettings.croppedHeight) / this.cropperSettings.croppedWidth;
      }

      let target = null;
      switch (type) {
        case 'logo':
          target = this.logoImage;
          break;
        case 'event':
          target = this.pdfEventImage;
          break;
        case 'place':
          target = this.pdfPlaceImage;
          break;
        case 'tour':
          target = this.pdfTourImage;
          break;
        case 'trip':
          target = this.pdfTripImage;
          break;
        case 'tpHomeImage':
          target = this.pdfTripImage;
          break;
        default:
          break;
      }

      if (target && target.nativeElement) {
        target.nativeElement.style.width = `${width}px`;
        target.nativeElement.style.height = `${height}px`;
      }
    });
  }

  public saveLogo(event: ButtonTriggerEvent) {
    let imageFile = this.logo.isDefault ? null : this.imageService.getImageFileByBase64(this.logoData.image);
    //let data = {isDefault: this.logo.isDefault, url: this.logoData.image};
    //this.customizationService.setLogo(this.hubName, data)
    this.customizationService
      .setLogoFile(this.hubName, { isDefault: this.logo.isDefault, image: imageFile })
      .finally(event.complete)
      .subscribe((fileName) => {
        this.alertify.successfully('Change the logo');
        let logo = new LogoCommand();
        logo.url = this.imageService.imageSourceUrl(fileName.fileName);
        logo.isDefault = this.logo.isDefault;
        this.hubLogoStore.logoCommand.next(logo);
        VisitorDataCache.logo = !logo.isDefault ? logo.url : '';
        // this.hubLogoStore.logoCommand.next(data);
        // VisitorDataCache.logo = !data.isDefault ? data.url : '';
      });
  }

  public onSelectedTabChange(event: MatTabChangeEvent) {     
    if (!window.location.href.includes('localhost')) {
      const authToken = localStorage.getItem(localStorageKeys.authToken);
      let tokenInfo = jwt_decode<TokenInfo>(authToken);
      try {
        let trackName = "click - customization - " + event.tab.textLabel;
        window['pendo'].track(trackName,{                    
          accountId: tokenInfo.userName,
          timestamp: Date.now(),
          hubName: this.hubName          
        });
      } catch (error) {
        console.error(error);
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/customization/style/style.component.ts